export default "__VITE_ASSET__e068fcdb__"